import { useUserStore } from "@/store/useUser";
import { onAuthStateChanged, User } from "firebase/auth";
import { Router } from "vue-router";
import { auth } from "./firebaseInit";

const getCurrentUser = () => new Promise<User>((resolve, reject) => {
  const removeListener = onAuthStateChanged(
    auth,
    (user) => {
      removeListener();
      resolve(user);
    },
    reject,
  );
});

export default (router: Router) => {
    router.beforeEach (async(to, from, next) => {
      const auth = useUserStore();
      const user = await getCurrentUser();

      auth.setAuth(user, user ? true : false);  

      if(to.matched.some((record) => record.meta.requiresAuth)) {
          if(!auth.isLoggedIn) {
            next({name: 'Login'});
          } else {
            next();
          }
        } else if(to.matched.some((record) => record.meta.requiresVisitor)) {
          if(!auth.isLoggedIn) {
              next();
            } else {
              next({name: 'Home'});
            }
        } else {
          next();
        }
      });
}
